export function literalMagnitudTipoSaldo (tipo_saldo) {
    if (tipo_saldo == 1)
        return "minutos";
    else if (tipo_saldo == 2)
        return "Euros";
    else
        return null;
}

export function literalSaldoProducto (saldo, tipo_saldo) {
    if (tipo_saldo > 0) {
        if ((saldo === null) || (saldo === undefined))
            return "-";
        else if (tipo_saldo == 1) {
            if (saldo < 60)
                return saldo + " minutos";
            else if (saldo < 1440)
                return Math.floor (saldo / 60) + " horas" + ((saldo % 60) > 0 ? ", " + (saldo % 60) + " minutos" : "");
            else
                return Math.floor (saldo / 1440) + " días, " + Math.floor ((saldo % 1440) / 60) + " horas" + ((saldo % 60) > 0 ? ", " + (saldo % 60) + " minutos" : "");
        } else if (tipo_saldo == 2)
            return saldo + " €";
    } else
        return null;
}

const utilAris = {
    literalMagnitudTipoSaldo: literalMagnitudTipoSaldo,
    literalSaldoProducto: literalSaldoProducto,
}
export default utilAris;